import { abbreviate } from "@/utils/misc/abbreviate";
import {
    AgCategoryAxisOptions,
    AgGroupedCategoryAxisOptions,
    AgGroupedCategoryDepthOptions,
    AgNumberAxisOptions,
} from "ag-charts-community";
import _ from "lodash";

function GroupedCategoryAxis(
    options: Omit<AgGroupedCategoryAxisOptions, "type">,
    depth: number = 1,
): AgGroupedCategoryAxisOptions {
    const visibleDepth: AgGroupedCategoryDepthOptions = {
        tick: { stroke: "#6B7280", width: 1 },
        label: { fontSize: 11 },
    };

    let depthOptions = [visibleDepth];

    if (depth === 2) {
        depthOptions = [
            { tick: { width: 0 } },
            { ...visibleDepth, label: { ...visibleDepth.label, spacing: 16 } },
        ];
    }

    const defaultOptions: AgGroupedCategoryAxisOptions = {
        type: "grouped-category",
        position: "bottom",
        depthOptions,
        line: {
            width: 1,
            stroke: "#9CA3AF",
        },
        gridLine: {
            enabled: false,
        },
        paddingInner: 0.3,
        label: { rotation: 0 },
    };

    return _.merge(defaultOptions, options);
}

function BasicCategoryAxis(
    options: Omit<AgCategoryAxisOptions, "type">,
): AgCategoryAxisOptions {
    const defaultOptions: AgCategoryAxisOptions = {
        type: "category",
        position: "bottom",
        line: {
            width: 1,
            stroke: "#9CA3AF",
        },
        gridLine: {
            enabled: false,
        },
        label: { avoidCollisions: true, rotation: 45 },
    };

    return _.merge(defaultOptions, options);
}

function MoneyAxis(
    options: Omit<AgNumberAxisOptions, "type">,
): AgNumberAxisOptions {
    const defaultOptions: AgNumberAxisOptions = {
        type: "number",
        position: "right",
        label: {
            formatter: (params) => "$" + abbreviate(`${params.value}`),
        },
        crosshair: {
            enabled: false,
        },
    };

    return _.merge(defaultOptions, options);
}

function PercentageAxis(
    options: Omit<AgNumberAxisOptions, "type">,
): AgNumberAxisOptions {
    const defaultOptions: AgNumberAxisOptions = {
        type: "number",
        position: "left",
        label: {
            formatter: (params) => `${(params.value * 100).toFixed(0)}%`,
        },
        crosshair: {
            enabled: false,
        },
    };

    return _.merge(defaultOptions, options);
}

export const Axis = {
    GroupedCategory: GroupedCategoryAxis,
    Money: MoneyAxis,
    Percentage: PercentageAxis,
    Category: BasicCategoryAxis,
};
